import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import Tooltip from "@/components-legacy/tooltip";
import { ShopExportDto } from "@babackapp/private-api-client/types";
import useTranslation, {
  Translation,
} from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { Card, CardContent } from "@babackapp/ui/components/card";
import { RefreshCwIcon } from "lucide-react";
import { format } from "date-fns";
import AddExportSettingsDialog from "./add-export-settings-dialog";
import UpdateExportSettingsDialog from "./update-export-settings-dialog";

export default function ExportSettings() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  return (
    <Card>
      <CardContent className="my-8">
        <div className="space-y-6 divide-y divide-gray-200">
          <div className="space-y-6">
            <div className="flex">
              <div className="flex-1">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {t("settings.integrations.exports.title")}
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  {t("settings.integrations.exports.subtitle")}
                </p>
              </div>
              <div>
                <AddExportSettingsDialog>
                  <Button>Add Export</Button>
                </AddExportSettingsDialog>
              </div>
            </div>
          </div>

          <div className="space-y-6 pt-6">
            {(shop.exports as ShopExportDto[]).map(
              (exportConfig: ShopExportDto, indexExport) => {
                return (
                  <FTPExport
                    key={`export-${indexExport}`}
                    exportConfig={exportConfig}
                  />
                );
              },
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

function FTPExport(props: { exportConfig: ShopExportDto }) {
  const t = useTranslation();
  // const [isExecuting, setIsExecuting] = useState(false);

  // const { mutateAsync: executeJob, isPending } = useExecuteExportJob();
  // const { mutateAsync: removeExport } = useRemoveExportMethod();

  const isPending = false;

  return (
    <UpdateExportSettingsDialog shopExport={props.exportConfig}>
      <div className="flex justify-between group">
        <div className="flex space-x-4 text-sm ">
          <div className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
            <svg
              className="-ml-0.5 mr-1.5 h-2 w-2 text-green-400"
              fill="currentColor"
              viewBox="0 0 8 8"
            >
              <circle cx={4} cy={4} r={3} />
            </svg>
            {props.exportConfig.type.toUpperCase()}
          </div>
          <div className="">{props.exportConfig.login.host}</div>
          <div className="text-gray-500">
            {`${t("settings.integrations.exports.lastRun")} ${
              props.exportConfig.lastRun > 0
                ? format(props.exportConfig.lastRun, "dd/MM/yyyy HH:mm")
                : t("misc.never")
            }`}
          </div>
          <div className="inline-flex space-x-2 items-center rounded-full px-2.5 py-0.5 text-xs font-medium text-gray-500">
            <Tooltip
              title=""
              description={
                <>
                  {props.exportConfig.filter.status.length > 0 && (
                    <p className="text-black font-semibold">
                      {props.exportConfig.filter.status.length}{" "}
                      {t("settings.integrations.exports.status")}
                    </p>
                  )}
                  {props.exportConfig.filter.status.map(
                    (subscription, index) => {
                      return (
                        <div className="mb-1" key={`status-${index}`}>
                          {t(
                            ("returnDetail.status." +
                              subscription) as Translation,
                          )}
                        </div>
                      );
                    },
                  )}
                  {props.exportConfig.filter.resolution.length > 0 && (
                    <p className="text-black font-semibold">
                      {props.exportConfig.filter.resolution.length}{" "}
                      {t("settings.integrations.exports.resolutions")}
                    </p>
                  )}
                  {props.exportConfig.filter.resolution.map(
                    (subscription, index) => {
                      return (
                        <div className="mb-1" key={`resolution-${index}`}>
                          {t(
                            ("newOrder.resolution" +
                              subscription) as Translation,
                          )}
                        </div>
                      );
                    },
                  )}
                </>
              }
            >
              <div>
                (
                {props.exportConfig.filter.status.length +
                  props.exportConfig.filter.resolution.length}{" "}
                {t("settings.integrations.exports.filters")} )
              </div>
            </Tooltip>
            {isPending && (
              <div className="flex items-center animate-spin text-gray-500">
                <RefreshCwIcon className="flex h-4  w-4 text-gray-400 -scale-y-100" />
              </div>
            )}
          </div>
        </div>
      </div>
    </UpdateExportSettingsDialog>
  );
}
